import React from "react";
import { profile } from "../../data/profile";
import { nodeId } from "../../data/connections";
import EvidenceCard from "../../components/investigation/EvidenceCard";
import EvidenceImage from "../../components/investigation/EvidenceImage";
import CaseStamp from "../../components/investigation/CaseStamp";
import { contactReport, detailFromContactReport } from "../../utils/evidenceDetail";

export const ContactSection = () => (
  <div className="contact-cluster">
    <EvidenceCard
      variant="report"
      pin="red"
      rotate={-0.6}
      className="final-report"
      nodeId={nodeId.report}
      detail={detailFromContactReport()}
    >
      <div className="final-report-body">
        <p className="case-kicker">Final report · {profile.caseNumber}</p>
        <h3>{contactReport.finding}</h3>
        <p className="case-summary">{contactReport.summary}</p>
        <p className="final-report-action">
          <span>Recommended action</span> Make contact.
        </p>
        <a href={`mailto:${profile.email}`} className="contact-mail">
          {profile.email}
        </a>
        <div className="contact-socials">
          {profile.socials
            .filter((link) => link.id !== "email")
            .map((link) => (
              <a key={link.id} href={link.href} target="_blank" rel="noreferrer" className="exhibit-link">
                {link.label} ↗
              </a>
            ))}
        </div>
      </div>
      <div className="final-report-side">
        <EvidenceImage
          src={profile.sketch}
          alt={`Sketch of ${profile.displayName} sitting cross-legged`}
          variant="portrait"
          pin="black"
          rotate={1.6}
          label={profile.sketchLabel}
          className="contact-portrait"
        />
        <CaseStamp tone="red" rotate={-8}>
          Case open
        </CaseStamp>
      </div>
    </EvidenceCard>
  </div>
);

export default ContactSection;
